export const getPhysician = orderingPhysician => {
  if (orderingPhysician) {
    return `${orderingPhysician.firstName} ${orderingPhysician.lastName}`
  } else {
    return '-'
  }
}

export const truncate = customParticipantID => {
  if (customParticipantID.length < 32) {
    return customParticipantID
  } else {
    return `...${customParticipantID.slice(-32)}`
  }
}

export const getTemplateNameFromTemplates = (templates, connectionTemplateID) => {
  const tmpl = templates.filter(t => t.id === connectionTemplateID)
  return tmpl.length > 0 ? tmpl[0].name : '-'
}

export const getTemplateName = enrollment => {
  const hasTemplateName = enrollment && enrollment.connectionTemplateName
  if (hasTemplateName) {
    return enrollment.connectionTemplateName
  } else {
    return '-'
  }
}



// WEBPACK FOOTER //
// ./src/legacy/components/PatientInfoUtils/index.js